const timeline = {
  filters: {
    status: {
      placeholder: 'סטטוס',
      options: {
        'new': 'חדש',
        'in-route': 'בנסיעה',
        'sent': 'נשלח',
        'approved': 'מאושר',
        'done': 'בוצע',
        'canceled': 'בוטל',
        'picking_up': 'אוסף',
      },
    },
    driver: 'נהג',
    vehicle: 'רכב',
    areas: 'אזורים',
    locations: 'תחנות',
    airportLocations: 'מיקומי שדה תעופה',
    driverShifts: 'הצג משמרות נהג',
    showUnassignedTrips: 'הצג נסיעות לא משויכות',
  },
  alerts: {
    etaChanged: 'זמן ההגעה המשוער לעצירות {{stopsIds}} בנסיעה {{tripId}} עודכן - הנהג קיבל התראה מהמערכת.',
  },
  assigenModal: {
    header: 'צוות נהג',
    description: 'אנא בחר נהג/רכב מהרשימה למטה',
    driver: 'בחר נהג',
    vehicle: 'בחר רכב',
    button: 'צוות',
  },
  toast: {
    toastSomethingWasWrong: 'משהו השתבש',
    assignedTrips: '{{numOfTrips}} נסיעות הוקצו',
  },
  empty: 'אין נסיעות ב-24 השעות האחרונות',
  driverInfo: {
    phoneNumber: 'מספר טלפון',
    lettersLeft: 'אותיות שנותרו',
    sendMessage: 'שלח הודעה',
  },
  actions: {
    manualAssign: 'הקצאה ידנית',
    removeAssign: 'הסרת הקצאה',
    assignInsights: 'הקצאת תובנות',
  },
  tripInformation: {
    trip: 'נסיעה #{{id}}',
  },
  stopInfo: {
    stopNumber: 'תחנה #{{number}}',
    tripId: 'נסיעה: {{id}}',
    pta: 'PTA: {{pta}}',
    eta: 'ETA: {{eta}}',
    totalReservations: '{{count}} הזמנות',
    pickupReservations: '{{count}} איסופים',
    dropReservations: '{{count}} הורדות',
    totalSeats: '{{count}} מושבים',
    table: {
      header: {
        reqAppt: 'בקשה/תור',
        passenger: 'נוסע',
        bookingId: 'מזהה הזמנה',
        seats: 'מושבים',
        zones: 'אזורים',
        attributes: 'מאפיינים',
      },
      sections: {
        pickups: 'איסופים',
        dropoffs: 'הורדות',
        request: 'בקשה',
        appt: 'תור',
      },
    },
  },
};

export default timeline;
